import {
  submitSearch,
  setTaxTerm,
  rbtProgramsQuery,
  programTaxClick,
  mapPickRegion,
  widgetGo,
  setWidgetTax,
  widgetColClick,
  secondColumnClick,
  setProgramsPaging,
  rbtSelectChoose,
  rbtSelectToggle,
  rbtSelectProgram,

} from './big-search.js';
import { autoscroller } from './autoscroller.js';

/* Carousel */
import { startCarousel, carouselIndicatorClick } from "./carousel";
import { rbtShowTags } from "./components";
import { mobileSubmenuToggle, openMobileMenu, closeMobileMenu } from "./mobile";

window.rbtShowTags = rbtShowTags;
window.startCarousel = startCarousel;
window.carouselIndicatorClick = carouselIndicatorClick;


window.addEventListener('DOMContentLoaded', (event) => {
  let processing = document.querySelectorAll('[data-process]');
  processing.forEach((element) => {
    switch (element.getAttribute('data-process')) {
      case 'doOverflowControls':
        autoscroller(element);
        break;
      case 'rbtProgramsQuery':
        rbtProgramsQuery(element);
        break;
    }
  });
});

const taxSearch = (e) => {
  const form = e.target.closest('form');
  const searchbar = e.target;
  const searchValue = searchbar.value.toLowerCase();
  const taxonomy = searchbar.dataset.taxonomy;
  const targetList = form.querySelector(`.${taxonomy}-list`);
  const filteredListContainer = form.querySelector(`.filtered-${taxonomy}-list`);

  if (targetList && filteredListContainer) {
    const items = Array.from(targetList.children);
    const filteredItems = items.filter(item => {
      const text = item.querySelector('label').textContent.toLowerCase();
      return text.includes(searchValue);
    });

    // Clear the filtered list container
    filteredListContainer.innerHTML = '';

    // Append filtered items
    filteredItems.forEach(item => {
      const clone = item.cloneNode(true);
      clone.addEventListener('click', (ev) => window.taxFilter(ev));
      filteredListContainer.appendChild(clone);
    });
  }
}

const switchTaxTabs = (e) => {
  const container = e.target.closest('.tabbed-container');
  const tabs = container.querySelectorAll('.tab');
  const panels = container.querySelectorAll('.panel');
  const dataTab = e.target.dataset.tab;
  const form = container.closest('form.rbt-display-form');
  for (let tab of tabs) {
    if (tab.dataset.tab === dataTab) { tab.classList.add('active') } else { tab.classList.remove('active'); }
  }
  for (let panel of panels) {
    if (panel.dataset.panel === dataTab) {

      panel.classList.add('active');

    } else {
      const inputs = panel.querySelectorAll('input[type="checkbox"]');
      inputs.forEach(input => input.checked = false);
      panel.classList.remove('active');
    }
  }
  let controlCol = form.querySelector('.control-col');
  if (controlCol && controlCol.style.maxHeight) {
    controlCol.style.maxHeight = controlCol.scrollHeight + 'px';
  }

}
const taxFilterClick = (e) => {
  let li = e.target.tagName === 'LI' ? e.target : e.target.closest('li');
  let checkbox = li.querySelector('input[type="checkbox"]');
  if (li && checkbox) {
    checkbox.checked = !checkbox.checked;
    li.classList.toggle('active');
  }
}
const clearFilters = (e) => {
  let form = e.target.closest('form.rbt-display-form');
  let root = form.closest('[data-process="rbtQuery"]');
  if (form && root) {
    /* clear all interests */
    let checkboxes = form.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(input => input.checked = false);
    let selects = form.querySelectorAll('select');
    selects.forEach(select => select.value = '');
    form.dataset.paged = 1;

    let hidden = form.querySelectorAll('input[type="hidden"]');
    hidden?.forEach(h => h.value = '');

    let defaultVals = form.querySelectorAll('div[data-default]');
    if (defaultVals) {
      defaultVals.forEach(d => d.textContent = d.dataset.default);
    }

    let tabs = form.querySelector('.tab');
    if (tabs) {
      let first = tabs[0] ? tabs[0] : false;
      first?.click();
    }

    e.target.classList.remove('active');
    rbtQuery(root);
  }
}

const rbqgetFormData = (form) => {
  // Get form data
  const data = Object.fromEntries(new FormData(form).entries());

  // Get all checked checkboxes
  const checks = form.querySelectorAll('input[type="checkbox"]:checked');

  // Initialize an object to hold the arrays of checked values
  const checkedData = {};

  // Iterate over each checked checkbox
  checks.forEach(checkbox => {
    const name = checkbox.name;
    const value = checkbox.value;
    const comparator = checkbox.dataset.comparator ? checkbox.dataset.comparator : 'in';
    const key = `${name}.${comparator}`;

    // If the key doesn't exist in the object, create an array for it
    if (!checkedData[key]) {
      checkedData[key] = [];
    }

    // Add the value to the appropriate array
    checkedData[key].push(value);
  });

  // Remove keys with `name` in `data`
  Object.keys(data).forEach(key => {
    if (key.includes('mos_interest')) {
      delete data[key];
    }
  });

  // Merge the form data with the checked data
  return Object.assign({}, data, checkedData);
}

const rbtSendFormRequest = (url, data) => {

}


const doClearFilters = (data, form) => {

  // Get dataset keys from the form
  const dataAttributeKeys = Object.keys(form.dataset);

  // Loop through the data object
  for (let key in data) {
    // Skip keys that exist in the form's dataset
    if (!dataAttributeKeys.includes(key)) {
      // Check if the value is not empty
      if (data[key] !== '') {
        // Activate the clear filters button
        const clearFilters = form.querySelector('.clear-filters .button');
        if (clearFilters) {
          clearFilters.classList.add('active');
        }
        break; // Exit the loop after finding the first non-empty value
      }
    }
  }
};
const getIt = async (url, nonce, data = false) => {
  let params = data ? new URLSearchParams(data).toString() : false;
  if (params) url = url + '?' + params;
  try {
    let response = await fetch(url, {
      method: 'GET',
      headers: {
        'X-WP-Nonce': nonce
      },
    });
    let rsp = await response.json();
    return rsp;

  } catch (error) {
    console.error('Error:', error);
    return error;
  }
}
const rbtSendDisplayRequest = async (url, data, nonce) => {
  let params = new URLSearchParams(data).toString();
  try {
    let response = await fetch(url + '?' + params, {
      method: 'GET',
      headers: {
        'X-WP-Nonce': nonce
      },

    });
    let data = await response.json();
    return data;
  } catch (error) {
    console.error('Error:', error);
    return error;
  }
}
const rbtPagination = (e) => {
  e.preventDefault();
  const newpage = e.target.dataset.paged;
  const blockroot = e.target.closest('[data-process="rbtQuery"]');
  const formwrap = blockroot ? blockroot.querySelector('.rbt-query-form-wrap') : null;
  if (formwrap) {
    const form = formwrap.querySelector('form');
    form.setAttribute('data-paged', newpage);
    rbtQuery(blockroot, false);
  }
}

const hideReminders = async (e) => {
  const section = e.target.closest('section');
  section.remove();
  let url = rbtQD.apiBase + 'hide_my_reminders/';
  let nonce = rbtQD.nonce;
  try {
    const response = await getIt(url, nonce);
  } catch {
    //error is logged in getIt
  }
}

const getSavedPosts = async (item) => {
  const posttype = item.getAttribute('data-saved-type');
  const showButton = item.hasAttribute('data-show-button') ? item.getAttribute('data-show-button') : false;
  let url = rbtQD.apiBase + 'get_saved_posttype/' + posttype + '/';
  if (showButton && showButton == "true") url += '?showButton=true'
  let nonce = rbtQD.nonce;
  try {
    const response = await getIt(url, nonce);
    if (response) {
      if (response.hasOwnProperty('payload') && response.payload) {
        /* Drop the HTML payload */
        item.innerHTML = response.payload;
        /* Now let's do the Gravity Forms stuff */
        let rbtQuery = item.querySelector('.rbt-query');
        let displayArea = rbtQuery ? rbtQuery.parentElement : false;
        if (displayArea) {
          displayArea.style.position = 'relative';
          //discover the height of the form
          let formBody = displayArea.closest('.gform-body');
          let h = formBody ? formBody.clientHeight : false;

          // Calculate the y offset of the displayArea from the form body
          let displayAreaRect = displayArea.getBoundingClientRect();
          let formBodyRect = formBody.getBoundingClientRect();
          let yOffset = displayAreaRect.top - formBodyRect.top;
          // Set the height of the displayArea to the remaining height of the form body minus 20px
          let remainingHeight = h - yOffset - 100;
          let query = displayArea.querySelector('.rbt-query');
          query.style.maxHeight = remainingHeight + 'px';

        }

      } else {
        if (response.hasOwnProperty('message')) {
          //maybe display error to user?
          console.log(response.message);
        }
      }
    }

  } catch {
    //error is logged in getIt
  }
}

const rbtQuery = async (item, ignorePagination = true) => {
  /* Need to populate the results portion of the rbtQuery form with the default */
  const handle = item.getAttribute('data-handle');
  const displaycontainer = item.querySelector('.rbt-query-results-wrap');
  const form = item.querySelector('.rbt-query-form-wrap form');
  if (!form || !form.hasAttribute('data-post_type')) {
    console.log("rbtQuery skipped, no form or post_type attribute");
    return;
  }
  const dataAttributes = form.dataset;

  /* Normally when a control is changed we want to reset the pagination to 1 */
  if (ignorePagination) dataAttributes.paged = 1;

  const data = form ? rbqgetFormData(form) : {};
  const queryobject = Object.assign({}, dataAttributes, data);
  let url = rbtQD.apiBase + 'queries/' + handle + '/results/';
  let nonce = rbtQD.nonce;
  doClearFilters(queryobject, form); // this checks and activates the clear filters button - not clearing the filters
  try {
    const response = await rbtSendDisplayRequest(url, queryobject, nonce);

    if (response) handleResponse(response, form);

  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

const taxFilter = async (e) => {
  const form = e.target.closest('form');
  const mainWrap = form.closest('.rbt-query');
  const displaycontainer = mainWrap.querySelector('.rbt-query-results-wrap');
  const loader = new Loader(displaycontainer);
  loader.doLoader();
  //handle click
  taxFilterClick(e);
  // get form data

  const handle = form.dataset.queryHandle;
  const dataAttributes = form.dataset;
  const data = form ? rbqgetFormData(form) : {};
  const queryobject = Object.assign({}, dataAttributes, data);
  //get form data-attributes
  let url = rbtQD.apiBase + 'queries/' + handle + '/results/';
  let nonce = rbtQD.nonce;
  doClearFilters(queryobject, form);
  try {
    const response = await rbtSendDisplayRequest(url, queryobject, nonce);

    if (response) handleResponse(response, form);

  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

/* */
const showQuickView = async (e) => {
  e.preventDefault();
  e.stopPropagation();
  const button = e.target;
  // Extract data attributes
  const imgSrc = button.getAttribute('data-header-img');
  const modalTitle = button.getAttribute('data-title');
  const learnMoreUrl = button.getAttribute('data-learnmore');
  const postId = button.getAttribute('data-postid');
  // Create the initial modal
  const modal = document.createElement('DIALOG');
  modal.classList.add('quick-view-modal');
  modal.id = 'quickview' + postId;
  modal.innerHTML = `<div class="quickview-card">
                          <div class="quickview-header">
                            <span class="close-button"></span>
                            <img src="${imgSrc}" alt="${modalTitle}" />
                            <h3>${modalTitle}</h3>
                          </div>
                          <div class="quickview-content">
                              <div class="loading-area">
                                <span class="rbt-loader" style="width:80px;height:80px">
                                  <svg version="1.1" id="Layer_1" class="loader" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 53.2 50" style="enable-background:new 0 0 53.2 50;"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#00843D;}.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFD100;}</style><g><path class="st0" d="M26.6,8.5C28.5,5.2,30.9,3,34,1.8c1.9-0.8,3.8-1.1,5.5-1c1.9,0.1,4,0.3,6,1.3c2.1,1.1,3.6,2.8,4.7,4.5 c1.1,1.6,1.8,3.6,2.1,6.1c0.3,2.5,0.1,4.6-0.5,6.5c-0.6,1.8-1.4,3.5-2.4,5.1c-0.9,1.6-2.2,3.1-3.7,4.7c-0.9,0.9-2.4,2.3-4.4,4.1 c-0.9,0.8-2.4,2.1-4.5,3.9c-1.8,1.5-3.1,2.7-4,3.5c-2.4,2.2-4.5,4.7-6.3,7.4c-1.7-2.7-3.8-5.2-6.2-7.4c-0.9-0.8-2.2-2-4-3.5 c-1.5-1.3-3-2.6-4.4-3.9c-2-1.8-3.5-3.2-4.4-4.1c-1.5-1.5-2.8-3.1-3.7-4.7c-1-1.6-1.8-3.3-2.4-5.1c-0.6-1.8-0.8-4-0.5-6.5 c0.3-2.5,1-4.5,2.1-6.1c1.1-1.6,2.2-3,4.4-4.1c2-1,4.4-1.6,6.3-1.7c1.8-0.1,3.6,0.3,5.5,1C22.3,3,24.8,5.2,26.6,8.5"/><path class="st1" d="M14.2,1.6c-0.2,0-0.3,0-0.5,0c-1.9,0.1-4.2,0.7-6,1.6c-1.9,1-3,2.2-4.1,3.8c-1,1.5-1.7,3.4-1.9,5.8 c-0.3,2.3-0.1,4.4,0.5,6.1c0.6,1.7,1.4,3.4,2.3,5c0.9,1.5,2.1,3.1,3.6,4.5c0.8,0.9,2.2,2.2,4.4,4.1c0.9,0.8,2.3,2.1,4.4,3.8 c1.8,1.5,3.1,2.7,4,3.5c2.1,2,4.1,4.2,5.7,6.6c1.7-2.4,3.6-4.6,5.7-6.6c0.9-0.9,2.3-2.1,4-3.5c1.5-1.3,3-2.5,4.4-3.8 c1.9-1.7,3.4-3.1,4.4-4.1c1.5-1.5,2.7-3.1,3.6-4.5c0.9-1.6,1.7-3.2,2.3-5c0.6-1.7,0.8-3.8,0.5-6.1c-0.3-2.4-0.9-4.3-1.9-5.8 c-1.3-2-2.8-3.3-4.4-4.2c-1.8-1-3.8-1.2-5.6-1.2c-0.1,0-0.3,0-0.5,0c-1.6,0-3.2,0.3-4.8,1c-2.9,1.1-5.3,3.3-7,6.4l-0.7,1.2 l-0.7-1.2c-1.8-3.1-4.1-5.2-7-6.4C17.3,1.9,15.7,1.6,14.2,1.6z M26.6,49.3l-0.7-1c-1.7-2.7-3.8-5.1-6.1-7.3c-0.9-0.8-2.2-2-4-3.5 c-1.5-1.3-3-2.6-4.5-3.9c-2.2-1.9-3.6-3.2-4.5-4.1c-1.5-1.6-2.8-3.2-3.8-4.8c-1-1.7-1.8-3.4-2.4-5.3c-0.7-2-0.9-4.2-0.6-6.8 c0.3-2.6,1-4.8,2.2-6.5C3.5,4.4,4.8,3,7,1.8c1.9-1,4.5-1.7,6.6-1.8c1.9-0.1,3.9,0.3,5.9,1c2.9,1.1,5.3,3.1,7.1,5.9 c1.8-2.8,4.2-4.8,7.1-5.9c2-0.8,3.9-1.1,5.9-1.1c2,0.1,4.2,0.3,6.3,1.4c1.9,1,3.5,2.5,5,4.7c1.2,1.7,1.9,3.9,2.2,6.5 c0.3,2.6,0.1,4.9-0.6,6.8c-0.7,1.9-1.5,3.6-2.4,5.3c-0.9,1.6-2.2,3.2-3.8,4.8c-1,1-2.5,2.4-4.5,4.1c-1,0.9-2.5,2.2-4.5,3.9 c-1.7,1.4-3,2.6-4,3.5c-2.4,2.2-4.4,4.6-6.1,7.3L26.6,49.3L26.6,49.3z"/> </g></svg>
                                </span>
                              </div>
                              <a href="${learnMoreUrl}" class="learn-more-link">Learn More</a>
                          </div>
                      </div>`;
  document.body.appendChild(modal);
  modal.showModal();
  const closeButton = modal.querySelector('.close-button');
  closeButton.addEventListener('click', () => { modal.close(); modal.remove(); });
  try {
    const url = rbtQD.apiBase + 'programs/quickview/' + postId;
    const nonce = rbtQD.nonce;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-WP-Nonce': nonce
      }
    });
    if (response) {
      const data = await response.json();
      console.log(data);
      const loadingArea = modal.querySelector('.loading-area');
      loadingArea.innerHTML = data.payload ?? '<p>Sorry, there was a problem getting this information.</p>';

    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }

}

const doRbtSelect = (e) => {

}

const doRbtSearch = async (e) => {
  const form = e.target.closest('form');
  const mainWrap = form.closest('.rbt-query');
  const displaycontainer = mainWrap.querySelector('.rbt-query-results-wrap');
  const loader = new Loader(displaycontainer);
  loader.doLoader();
  const handle = form.dataset.queryHandle;
  const dataAttributes = form.dataset;
  const data = form ? rbqgetFormData(form) : {};
  const queryobject = Object.assign({}, dataAttributes, data);
  //get form data-attributes
  let url = rbtQD.apiBase + 'queries/' + handle + '/results/';
  let nonce = rbtQD.nonce;
  doClearFilters(queryobject, form);
  try {
    const response = await rbtSendDisplayRequest(url, queryobject, nonce);
    if (response) handleResponse(response, form);

  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

const rbtShowFilters = (e) => {
  let form = e.target.closest('form.rbt-display-form');
  let controlCol = form.querySelector('.control-col');
  /* expand the maxHeight */
  if (controlCol) {
    if (e.target.classList.contains('active')) {
      e.target.classList.remove('active');
      let innerT = e.target.classList.contains('inner-text') ? e.target : e.target.querySelector('.inner-text');
      if (innerT) innerT.innerText = 'Show Filters';
      controlCol.style.maxHeight = null;
    } else {
      e.target.classList.add('active');
      let innerT = e.target.classList.contains('inner-text') ? e.target : e.target.querySelector('.inner-text');
      if (innerT) innerT.innerText = 'Hide Filters';
      controlCol.style.maxHeight = controlCol.scrollHeight + 'px';
    }
  }


}

/* 
 * Updates the innerHTML of select boxes with new data
*/
const updateRbtSelects = (selects, data) => {
  // Update Selects
  selects.forEach(select => {
    if (Object.keys(data).includes(select.name)) {
      const active = select.value;
      const newOptions = data[select.name];
      let optionString = `<option value"">${select.dataset.label}</option>`;

      newOptions.forEach(option => {
        const selectedString = option.term_id == active ? ' selected' : '';
        optionString += `<option value="${option.term_id}" data-slug="${option.slug}"${selectedString}>${option.name}</option>`;
      });

      select.innerHTML = optionString;
    }
  });
}

/* 
 * Updates the innerHTML of Fake Selects with new data
*/
const updateRbtFakeSelects = (fs, data) => {
  // Update Selects
  fs.forEach(select => {
    let fs_input = select.querySelector('input[type="hidden"]');
    if (Object.keys(data).includes(fs_input.name)) {
      const newOptions = data[fs_input.name];
      let optionString = '';
      let optionUL = select.querySelector('ul.select-options');
      newOptions.forEach(option => {
        optionString += `<li data-value="${option.term_id}" data-slug="${option.slug}" onclick="rbtSelectChoose(event)"><span class="rbt-select-icon" data-icon-url="${option.icon}"></span> ${option.name}</li>`;
      });
      optionUL.innerHTML = optionString;
    }
  });
}


/*
* Updates the form filters based on the response from the API.
* @param {Object} data - The data containing updated options for form controls.
* @param {HTMLElement} form - The form element to update.
*/
const updateFormFilters = async (data, form) => {
  // Get all kinds of Form Controls
  const selects = form.querySelectorAll('select');
  const fakeSelects = form.querySelectorAll('.rbt-select.fake-select');

  // Update Selects
  updateRbtSelects(selects, data);

  // Update Fake Selects with data-icon
  updateRbtFakeSelects(fakeSelects, data);

  //switch out <span class="rbt-select-icon" data-icon-url="${option.icon}"></span> with the outerHTML of the icon
};

/**
 *
 * @param {*} response - response from any RBT Query
 * @param {*} form - form Element that was used to make the query
 */
const handleResponse = (response, form) => {

  const mainWrap = form.closest('.rbt-query');
  const displaycontainer = mainWrap.querySelector('.rbt-query-results-wrap');

  displaycontainer.innerHTML = '';
  displaycontainer.innerHTML = response.payload ? response.payload : "<p>Sorry, there was a problem getting this information.</p>"; // Update this part to reflect actual data
  let currentPosts = response.hasOwnProperty('currentposts') ? response.currentposts : 0;
  let totalPosts = response.hasOwnProperty('totalposts') ? response.totalposts : 0;
  updateFormFooters(currentPosts, totalPosts, form);
  if (response.hasOwnProperty('formFilterReset')) {
    //reset the filters based on response
    //updateFormFilters(response.formFilterReset, form);
  }
}
/**
 *
 * @param {*} currentPosts
 * @param {*} totalPosts
 * @param {*} form
 */
const updateFormFooters = (currentPosts, totalPosts, form) => {
  let footer = form.querySelector('.control-row.footer');
  if (footer) {
    let currentFilter = footer.querySelector('.current-filter');
    let queryTotal = footer.querySelector('.query-total');
    currentFilter.innerHTML = currentPosts;
    queryTotal.innerHTML = totalPosts;
  }
}
// Attach the search event to the search box
document.addEventListener('DOMContentLoaded', () => {
  const searchbars = document.querySelectorAll('input[data-taxonomy]');
  searchbars.forEach(searchbar => {
    searchbar.addEventListener('input', taxSearch);
    /* initial state taxonomy pills */
    let searchParent = searchbar.parentElement;
    let filteredList = searchParent.nextElementSibling;
    if (filteredList && filteredList.classList.contains('filtered-mos-interest-list')) {
      Array.from(filteredList.children).forEach(item => {
        item.addEventListener('click', (ev) => window.taxFilter(ev));
      });
    }
  });
});

const viewMore = (e) => {
  e.preventDefault();
  let content = e.target.closest('.entry-item-content');
  let expander = content.querySelector('.expander');
  let expanderContent = content.querySelector('.expander-content');
  if (expander.classList.contains('active')) {
    expander.classList.remove('active');
    expanderContent.classList.add('active')
    expanderContent.style.maxHeight = expanderContent.scrollHeight + 'px';
  } else {
    expander.classList.add('active');
    expanderContent.style.maxHeight = null;
  }
}

function toggleSearch(event) {
  const searchWrap = event.target.closest('.search-wrap');
  const navbar = searchWrap.previousElementSibling;
  searchWrap.classList.toggle('active');
  navbar.classList.toggle('hidden');
  searchWrap.querySelector('input').focus();

}
function toggleUserSettings(event) {
  const settingsRoot = event.target.closest('.user-settings');
  const menu = settingsRoot.querySelector('.user-settings-menu');
  menu.classList.toggle('active');
  if (menu.classList.contains('active')) menu.classList.add('dismissable');
  event.stopPropagation();
}
function toggleLightMode(event) {

  const body = document.querySelector('body');
  const tog = event.target;
  const menuRoot = event.target.closest('.light-dark-toggle');
  const text = menuRoot.querySelector('.mode-text');
  if (text) {
    text.innerHTML = tog.checked ?
      '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.56 122.88"><defs><style>.cls-1{fill-rule:evenodd;}</style></defs><title>night</title><path class="cls-1" d="M121.85,87.3A64.31,64.31,0,1,1,36.88.4c2.94-1.37,5.92.91,4.47,4.47a56.29,56.29,0,0,0,75.75,77.4l.49-.27a3.41,3.41,0,0,1,4.61,4.61l-.35.69ZM92.46,74.67H92A16.11,16.11,0,0,0,76.2,58.93v-.52a15.08,15.08,0,0,0,11-4.72,15.19,15.19,0,0,0,4.72-11h.51a15.12,15.12,0,0,0,4.72,11,15.12,15.12,0,0,0,11,4.72v.51A16.13,16.13,0,0,0,92.46,74.67Zm10.09-46.59h-.27a7.94,7.94,0,0,0-2.49-5.81A7.94,7.94,0,0,0,94,19.78v-.27A7.94,7.94,0,0,0,99.79,17a8,8,0,0,0,2.49-5.8h.27A8,8,0,0,0,105,17a8,8,0,0,0,5.81,2.49v.27A8,8,0,0,0,105,22.27a7.94,7.94,0,0,0-2.49,5.81Zm-41.5,8h-.41a12.06,12.06,0,0,0-3.78-8.82A12.06,12.06,0,0,0,48,23.5v-.41a12.07,12.07,0,0,0,8.82-3.78,12.09,12.09,0,0,0,3.78-8.82h.41a12.08,12.08,0,0,0,3.77,8.82,12.09,12.09,0,0,0,8.83,3.78v.41a12.09,12.09,0,0,0-8.83,3.78,12.08,12.08,0,0,0-3.77,8.82Z"/></svg>'
      :
      '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 240 240" style="enable-background:new 0 0 240 240; width:16px;height:16px;" xml:space="preserve"><g><path fill="#6D6E70" d="M58.57,25.81c-2.13-3.67-0.87-8.38,2.8-10.51c3.67-2.13,8.38-0.88,10.51,2.8l9.88,17.1c2.13,3.67,0.87,8.38-2.8,10.51 c-3.67,2.13-8.38,0.88-10.51-2.8L58.57,25.81L58.57,25.81z M120,51.17c19.01,0,36.21,7.7,48.67,20.16 C181.12,83.79,188.83,101,188.83,120c0,19.01-7.7,36.21-20.16,48.67c-12.46,12.46-29.66,20.16-48.67,20.16 c-19.01,0-36.21-7.7-48.67-20.16C58.88,156.21,51.17,139.01,51.17,120c0-19.01,7.7-36.21,20.16-48.67 C83.79,58.88,101,51.17,120,51.17L120,51.17z M158.27,81.73c-9.79-9.79-23.32-15.85-38.27-15.85c-14.95,0-28.48,6.06-38.27,15.85 c-9.79,9.79-15.85,23.32-15.85,38.27c0,14.95,6.06,28.48,15.85,38.27c9.79,9.79,23.32,15.85,38.27,15.85 c14.95,0,28.48-6.06,38.27-15.85c9.79-9.79,15.85-23.32,15.85-38.27C174.12,105.05,168.06,91.52,158.27,81.73L158.27,81.73z M113.88,7.71c0-4.26,3.45-7.71,7.71-7.71c4.26,0,7.71,3.45,7.71,7.71v19.75c0,4.26-3.45,7.71-7.71,7.71 c-4.26,0-7.71-3.45-7.71-7.71V7.71L113.88,7.71z M170.87,19.72c2.11-3.67,6.8-4.94,10.48-2.83c3.67,2.11,4.94,6.8,2.83,10.48 l-9.88,17.1c-2.11,3.67-6.8,4.94-10.48,2.83c-3.67-2.11-4.94-6.8-2.83-10.48L170.87,19.72L170.87,19.72z M214.19,58.57 c3.67-2.13,8.38-0.87,10.51,2.8c2.13,3.67,0.88,8.38-2.8,10.51l-17.1,9.88c-3.67,2.13-8.38,0.87-10.51-2.8 c-2.13-3.67-0.88-8.38,2.8-10.51L214.19,58.57L214.19,58.57z M232.29,113.88c4.26,0,7.71,3.45,7.71,7.71 c0,4.26-3.45,7.71-7.71,7.71h-19.75c-4.26,0-7.71-3.45-7.71-7.71c0-4.26,3.45-7.71,7.71-7.71H232.29L232.29,113.88z M220.28,170.87 c3.67,2.11,4.94,6.8,2.83,10.48c-2.11,3.67-6.8,4.94-10.48,2.83l-17.1-9.88c-3.67-2.11-4.94-6.8-2.83-10.48 c2.11-3.67,6.8-4.94,10.48-2.83L220.28,170.87L220.28,170.87z M181.43,214.19c2.13,3.67,0.87,8.38-2.8,10.51 c-3.67,2.13-8.38,0.88-10.51-2.8l-9.88-17.1c-2.13-3.67-0.87-8.38,2.8-10.51c3.67-2.13,8.38-0.88,10.51,2.8L181.43,214.19 L181.43,214.19z M126.12,232.29c0,4.26-3.45,7.71-7.71,7.71c-4.26,0-7.71-3.45-7.71-7.71v-19.75c0-4.26,3.45-7.71,7.71-7.71 c4.26,0,7.71,3.45,7.71,7.71V232.29L126.12,232.29z M69.13,220.28c-2.11,3.67-6.8,4.94-10.48,2.83c-3.67-2.11-4.94-6.8-2.83-10.48 l9.88-17.1c2.11-3.67,6.8-4.94,10.48-2.83c3.67,2.11,4.94,6.8,2.83,10.48L69.13,220.28L69.13,220.28z M25.81,181.43 c-3.67,2.13-8.38,0.87-10.51-2.8c-2.13-3.67-0.88-8.38,2.8-10.51l17.1-9.88c3.67-2.13,8.38-0.87,10.51,2.8 c2.13,3.67,0.88,8.38-2.8,10.51L25.81,181.43L25.81,181.43z M7.71,126.12c-4.26,0-7.71-3.45-7.71-7.71c0-4.26,3.45-7.71,7.71-7.71 h19.75c4.26,0,7.71,3.45,7.71,7.71c0,4.26-3.45,7.71-7.71,7.71H7.71L7.71,126.12z M19.72,69.13c-3.67-2.11-4.94-6.8-2.83-10.48 c2.11-3.67,6.8-4.94,10.48-2.83l17.1,9.88c3.67,2.11,4.94,6.8,2.83,10.48c-2.11,3.67-6.8,4.94-10.48,2.83L19.72,69.13L19.72,69.13z"/></g></svg>';
    if (tog.checked) {
      text.classList.remove('light');
      body.classList.remove('light');
      text.classList.add('dark');
      body.classList.add('dark');

    } else {
      text.classList.remove('dark');
      body.classList.remove('dark');
      text.classList.add('light');
      body.classList.add('light');
    }
  }
  if (tog.checked) {
    body.classList.add('dark');
  } else {
    body.classList.remove('dark');
  }

  //update the setting in Cookie or if not available session
  const current_state = tog.checked ? "dark" : "light";

  document.cookie = `sft_theme=${current_state}; path=/; max-age=${60 * 60 * 24 * 30}; SameSite=Lax`;

}


function mobileFooterClick(e) {
  e.preventDefault();
  const target = e.target;
  let li = target.closest('LI');
  let subMenu = li.querySelector('.sub-menu');
  if (subMenu) {
    li.classList.toggle('active');
  }
}
document.addEventListener('click', function (e) {
  // Dismiss elements
  let dismissables = document.querySelectorAll('.dismissable');
  for (let d of dismissables) {
    if (d !== e.target && !d.contains(e.target)) {
      d.classList.remove('active');
    }
  }
});

/* Bring into global scope */
window.rbtSelectProgram = rbtSelectProgram;
window.rbtSelectChoose = rbtSelectChoose;
window.rbtSelectToggle = rbtSelectToggle;
window.setProgramsPaging = setProgramsPaging;
window.mapPickRegion = mapPickRegion;
window.showQuickView = showQuickView;
window.submitSearch = submitSearch;
window.taxSearch = taxSearch;
window.setTaxTerm = setTaxTerm;
window.taxFilter = taxFilter;
window.doRbtSearch = doRbtSearch;
window.rbtQuery = rbtQuery;
window.clearFilters = clearFilters;
window.getSavedPosts = getSavedPosts;
window.rbtProgramsQuery = rbtProgramsQuery;
window.programTaxClick = programTaxClick;
//Home page widget js
window.widgetGo = widgetGo;
window.setWidgetTax = setWidgetTax;
window.widgetColClick = widgetColClick;
window.secondColumnClick = secondColumnClick;
window.viewMore = viewMore;

window.mobileFooterClick = mobileFooterClick;
window.mobileSubmenuToggle = mobileSubmenuToggle;
window.closeMobileMenu = closeMobileMenu;
window.openMobileMenu = openMobileMenu;
window.submitSearch = submitSearch;
window.toggleSearch = toggleSearch;
window.toggleLightMode = toggleLightMode;
window.toggleUserSettings = toggleUserSettings;